<template>
  <iframe :id="id" style="opacity: 1;" @load.once="iFrameLoad()" class="page-iframe" src="/empty.html" v-show="!error"></iframe>
  <ErrorScreen v-show="error" :error="error"/>
</template>

<script>
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import ErrorScreen from "@/components/ErrorScreen";
import {
  prepareTransplantHtml,
  verifyTransplantApplied,
  writeTransplantDocument,
} from "@/utils/transplant";

export default {
  name: 'page-renderer',
  props: {
    page: String,
    renderMode: {
      type: String,
      default: undefined
    }
  },
  components: {
    ErrorScreen

  },
  data () {
    const pageURL = new URL(this.page);
    return {
      id: null,
      error: '',
      targetDomain: pageURL.host,
      localDomain: window.location.host
    }
  },
  beforeCreate() {
    const that = this;

    // Listen to messages from child window (iframe)
    window.addEventListener('message', function(event) {
      const data = event.data;

      // Check that the message came from the iframe and that it is a PEP message
      if(typeof data.type !== "undefined"  && data.type === 'pep') {

        // Check for errors
        // Code in iFrame: window.parent.postMessage({ type: 'pep', action: 'error', message: yourErrorMessage}, "*");
        if(data.action === 'error') {
          that.setError(data.message);
          that.$emit('rendered', that.page)
        }

        // Check for reload
        // Code in iFrame: window.parent.postMessage({ type: 'pep', action: 'reload', message: 'Success' }, "*");
        if (data.action === 'reload') {
          const iFrame = document.querySelector('#' + that.id);

          // Reload iframe if it is loaded
          if(iFrame && iFrame.contentWindow) {
            that.$emit('reload')
            console.log('Reloading iframe...')
            // add event listener to reload iframe only once
            iFrame.addEventListener('load', () => that.iFrameLoad(), { once: true });

            // reload iframe
            iFrame.contentWindow.location.reload();
          }
        }

        // Check for navigate
        // Code in iFrame: window.parent.postMessage({ type: 'pep', action: 'navigate', message: 'name' }, "*");
        if (data.action === 'navigate' && data.message) {
          const route = that.$store.getters.navigation[data.message.toLowerCase()];

          if (typeof route === "undefined") {
            console.error('Route not found: ' + data.message.toLowerCase());
          } else {
            that.$router.push(route.url);
          }
        }
      }
    });
  },

  mounted () {
    this.id = "f" + uuidv4();

  },
  methods: {
    iFrameLoad() {
      const that = this;
      const iFrame = document.querySelector('#' + this.id);
      const mode = this.getRenderMode();

      if(mode === 'direct') {
        console.log('PEP-Render: using direct mode for', this.page);
        this.renderDirect(iFrame);
        return;
      }

      console.log('PEP-Render: using transplant mode for', this.page);

      axios({
        method: 'get',
        url: this.page,
      }).then(function (response) {
        const documentHtml = prepareTransplantHtml(
          response.data,
          (href) => that.getTargetHREF(href)
        );
        const iFrameDocument = iFrame.contentDocument || iFrame.contentWindow.document;

        writeTransplantDocument(iFrameDocument, documentHtml);

        verifyTransplantApplied(iFrameDocument).then((applied) => {
          if (!applied && window.navigator.onLine) {
            console.warn(
              'PEP-Render: transplant styles not applied, falling back to direct mode for',
              that.page
            );
            that.renderDirect(iFrame);
            return;
          }

          that.$emit('rendered', that.page);
        });
      }).catch((e) => {
        console.log("PEP-Log: ", e)
        if(window.navigator.onLine) {
          try {
            console.warn('PEP-Render: transplant failed, falling back to direct mode for', that.page);
            that.renderDirect(iFrame);
          } catch (err) {
            that.setError(err)
            that.$emit('rendered', that.page)
          }
        } else {
          that.setError("you are offline")
          that.$emit('rendered', that.page)
        }
      });
    },

    getRenderMode() {
      return this.renderMode === 'direct' ? 'direct' : 'transplant';
    },

    renderDirect(iFrame) {
      if(!iFrame) {
        this.setError('iframe not found');
        this.$emit('rendered', this.page);
        return;
      }

      iFrame.style.opacity = "1";
      let rendered = false;
      const emitRendered = () => {
        if (rendered) {
          return;
        }
        rendered = true;
        clearTimeout(fallbackTimer);
        this.$emit('rendered', this.page);
      };
      const fallbackTimer = setTimeout(emitRendered, 8000);

      iFrame.addEventListener('load', emitRendered, { once: true });
      iFrame.addEventListener('error', emitRendered, { once: true });
      iFrame.src = this.page;
    },

    getTargetHREF(href) {
      const replacementDomain = href.indexOf("/" + this.$store.getters.ticket) >= 0 ? this.localDomain + "/" + this.$store.getters.ticket + "/" + this.$store.getters.token : this.localDomain;
      const replacementDomain2 = href.indexOf("/" + this.$store.getters.ticket) >= 0 ? this.localDomain + "/" + this.$store.getters.ticket : this.localDomain;
      const replacementDomain3 = href.indexOf("/" + this.$store.getters.ticket) >= 0 ? this.localDomain : this.localDomain;
      return href.replace(replacementDomain, this.targetDomain).replace(replacementDomain2, this.targetDomain).replace(replacementDomain3, this.targetDomain)
    },

    setError(message) {
      this.error = message;
    }
  }
}
</script>